module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_15.386bdea0.pdf";